import { createModuleWithSlices } from "@comact/crc";
import * as requests from "./requests";
import slices, { actions } from "./slices";
export * from "./model";

export const SalesforceModule = createModuleWithSlices({
    slices, actions, requests,
});